import $ from 'jquery'
import Isotope from 'isotope-layout'
import imagesLoaded from 'imagesloaded'
import { debounce, getTextNodesIn } from '../functions'

imagesLoaded.makeJQueryPlugin($)

let faqCategories = $('[data-faq-categories]').attr('data-faq-categories')
if (faqCategories != undefined) {
    faqCategories = faqCategories.split(',')

    let isoFaq = []

    $.each(faqCategories, function () {
        let isoFaqTemp = ''
        const parent = $('.js-container-' + this)
        if (parent.length) {
            isoFaqTemp = new Isotope('.js-container-' + this, {
                itemSelector: '.js-iso-item',
                transitionDuration: 0,
                percentPosition: true,
                masonry: {
                    columnWidth: 33,
                },
            })
        }

        const search = $('.js-faq-iso-search').keyup(
            debounce(function () {
                const qsRegex = new RegExp(search.val(), 'gi')

                isoFaqTemp.arrange({
                    filter: function () {
                        const post = $(this)
                        const text = getTextNodesIn(post[0])

                        let hasText = qsRegex ? text.match(qsRegex) : true

                        return hasText
                    },
                })
            }, 200)
        )

        search.on('blur', function () {
            const qsRegex = new RegExp(search.val(), 'gi')

            isoFaqTemp.arrange({
                filter: function () {
                    const post = $(this)
                    const text = getTextNodesIn(post[0])

                    let hasText = qsRegex ? text.match(qsRegex) : true

                    return hasText
                },
            })
        })

        isoFaq.push(isoFaqTemp)
    })
}

let catIso = ''

const parent = $('.js-cat-iso')
if (parent.length != 0) {
    catIso = new Isotope('.js-cat-iso', {
        itemSelector: '.js-cat-iso-item',
        percentPosition: true,
        transitionDuration: 0,
        layoutMode: 'fitRows',
    })

    parent.imagesLoaded(function () {
        catIso.layout()
    })

    $('.js-faq-select').on('change', function () {
        var vals = [$('.js-faq-select').val()]

        if (vals.length === 0) {
            catIso.arrange({ filter: '*' })
            return
        }

        catIso.arrange({
            filter: function () {
                const posts = $(this)

                const attr = posts.attr('data-categories')
                const categories = attr.includes(',') ? attr.split(',') : [attr]
                const newCategories = categories.map(Number)
                let hasCategory = false

                if (newCategories.length > 0) {
                    for (let i = 0; i < vals.length; i++) {
                        if (
                            newCategories.includes(parseInt(vals[i])) ||
                            vals[i] === 'all'
                        ) {
                            hasCategory = true
                        }
                    }
                }

                const post = $(this)
                const text = getTextNodesIn(post[0])
                const qsRegex = new RegExp($('.pt-faq input[type="text"]').val(), 'gi')

                let hasText = qsRegex ? text.match(qsRegex) : true

                return hasCategory && hasText
            },
        })
    })
}

const search = $('.js-faq-iso-search').keyup(
    debounce(function () {
        const qsRegex = new RegExp(search.val(), 'gi')
        const vals = [$('.js-faq-select').val()]

        catIso.arrange({
            filter: function () {
                const faq = $(this)

                const attr = faq.attr('data-categories')
                const categories = attr.includes(',') ? attr.split(',') : [attr]
                const newCategories = categories.map(Number)
                let hasCategory = false

                if (vals[0] == null) {
                    hasCategory = true
                }

                if (newCategories.length > 0) {
                    for (let i = 0; i < vals.length; i++) {
                        if (
                            newCategories.includes(parseInt(vals[i])) ||
                            vals[i] === 'all'
                        ) {
                            hasCategory = true
                        }
                    }
                }

                const post = $(this)
                const text = getTextNodesIn(post[0])

                let hasText = qsRegex ? text.match(qsRegex) : true

                return hasCategory && hasText
            },
        })
    }, 200)
)

search.on('blur', function () {
    const qsRegex = new RegExp(search.val(), 'gi')
    const vals = [$('.js-faq-select').val()]

    catIso.arrange({
        filter: function () {
            const faq = $(this)

            const attr = faq.attr('data-categories')
            const categories = attr.includes(',') ? attr.split(',') : [attr]
            const newCategories = categories.map(Number)
            let hasCategory = false

            if (vals[0] == null) {
                hasCategory = true
            }

            if (newCategories.length > 0) {
                for (let i = 0; i < vals.length; i++) {
                    if (newCategories.includes(parseInt(vals[i])) || vals[i] === 'all') {
                        hasCategory = true
                    }
                }
            }

            const post = $(this)
            const text = getTextNodesIn(post[0])

            let hasText = qsRegex ? text.match(qsRegex) : true

            return hasCategory && hasText
        },
    })
})